import React from 'react'

import widgetService from 'live/services/widgets'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'

import { rigFloorReducer } from './RigFloorReducer'
import { RigFloorMessage, RigFloorState } from './types'
import { withSuspenseWrapper } from '../../components/SuspenseWrapper'
import { type, name, description } from '../constants'
import dashboardService from 'live/services/dashboard'
import { CutOffsFilterComponent } from '../filters/cutOffsFilter'

const WrapperRigFloorComponent = withSuspenseWrapper(
    React.lazy(() => import('./components/EditingTable').then(module => ({ default: module.KpiRigFloorEntry })))
)

const RigFloorWidget = reactWidgetWrapper<RigFloorState, RigFloorMessage, DefaultChartConfigs>(
    WrapperRigFloorComponent,
    rigFloorReducer,
    {
        mapConfigToProps(configs) {
            return {
                widget: configs.widget,
                dashboardTheme: configs.dashboardContext?.theme
            }
        }
    }
)

dashboardService.dashboardFiltersFormRegistry.register(CutOffsFilterComponent)

widgetService.register({
    type: type,
    name,
    description,
    config: {
        color: 'red'
    },
    policies: {
        handleOwnMissingData: true
    },
    impl: RigFloorWidget
})
